import { render, staticRenderFns } from "./dynamic-data-content.vue?vue&type=template&id=0f9840ef&scoped=true"
import script from "./dynamic-data-content.vue?vue&type=script&lang=js"
export * from "./dynamic-data-content.vue?vue&type=script&lang=js"
import style0 from "./dynamic-data-content.vue?vue&type=style&index=0&id=0f9840ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9840ef",
  null
  
)

export default component.exports